/** "42 min", "3 h 05 min": how long someone has been waiting, in queues and worklists. */
export function formatWaiting(minutes: number): string {
  if (minutes < 60) return `${String(minutes)} min`;
  const hours = Math.floor(minutes / 60);
  return `${String(hours)} h ${String(minutes % 60).padStart(2, '0')} min`;
}
